/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/itpRecipients.ts
 * FILE_ID: JOBHUB-QA-ITP-RECIPIENTS-LIST-001
 * PURPOSE: Split a To, CC or BCC string into unique addresses.
 */

export function splitRecipients(text: string): string[] {
  const seen = new Set<string>()
  return text.split(/[,;\n]+/).map((part) => part.trim()).filter((part) => {
    const key = part.toLowerCase()
    if (!part || seen.has(key)) return false
    seen.add(key)
    return true
  })
}
